import {getCurrency} from "./localization";

/**
 * @return {currency: string, locale: string, paymentSystem: string, pspIsPayyo: boolean, pspIsStripe: boolean, primary_language: string}
 */
export const siteSettings = () => {
	return window.LocalizationConfig;
};


/**
 * Preparation for multi-currency products.
 *
 * @see getCurrency
 * @return {*}
 */
export const getUserCurrency = () => {
	return getCurrency();
}

